import { useAutoAnimate } from '@formkit/auto-animate/react';
import { TitleRow } from 'components/TitleRow';
import { FC } from 'react';
import { UncreditedPaymentItem } from 'ui/UncreditedPaymentItem';
import styles from './UncreditedPaymentsList.module.scss';
import { UncreditedPaymentItem as UncreditedPaymentItemType } from 'redux/Api/uncreditedPaymentsApi/type';

interface UncreditedPaymentsListProps {
  data?: UncreditedPaymentItemType[];
}

export const UncreditedPaymentsList: FC<UncreditedPaymentsListProps> = ({ data }) => {
  const [parent] = useAutoAnimate({ duration: 300 });

  const dataTitle = [
    'ID',
    'Банковский ID',
    'Дата платежа',
    'Назначение платежа',
    'Плательщик',
    'Сумма, ₽',
  ];

  return (
    <div ref={parent} className={styles.root}>
      <TitleRow data={dataTitle} title='payments' />
      {data?.length ? (
        data?.map((item) => <UncreditedPaymentItem key={item.id} payment={item} />)
      ) : (
        <div className={styles.root_nothing}>
          <p>Ничего не найдено</p>
        </div>
      )}
    </div>
  );
};
